function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Primary_Button",
  transform: "translate(-126.000000, -13.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(126.000000, 13.000000)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFFEFD",
  opacity: 0.300000012,
  cx: 12,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("g", {
  id: "chevron-down-(1)",
  transform: "translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000) translate(8.000000, 10.000000)",
  stroke: "#FFFEFD",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "1.13686838e-13 0 4 4 8 0"
})))))));

var SvgButtonArrow = function SvgButtonArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButtonArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/button-arrow.86be07e5.svg";
export { ForwardRef as ReactComponent };